import { useMemo, useState } from 'react';
import Table from '@enerex/unified-ui-react/Table';
import LookupActions from './LookupActions';
import LookupToolbar, { STATUS_OPTIONS } from './LookupToolbar';

const EMPTY_ROWS = [];

const LookupTable = ({ definition, columns, rows = EMPTY_ROWS, loading = false, remote, onAdd, onEdit, onDelete, onAddAliases }) => {
    const [search, setSearch] = useState('');
    const [status, setStatus] = useState(STATUS_OPTIONS[0]);
    const data = useMemo(() => remote ? rows : rows.filter((row) => {
        const matchesStatus = status.value === 'all' || row.active === (status.value === 'active');
        const matchesSearch = !search || columns.some(({ accessorKey }) => (
            accessorKey && String(row[accessorKey] ?? '').toLocaleLowerCase().includes(search.toLocaleLowerCase())
        ));
        return matchesStatus && matchesSearch;
    }), [rows, status, search, columns, remote]);

    const tableColumns = useMemo(() => [...columns, {
        id: 'actions', header: 'Actions', enableSorting: false,
        cell: ({ row }) => <LookupActions record={row.original} onEdit={onEdit} onDelete={onDelete} onAddAliases={onAddAliases} />,
    }], [columns, onEdit, onDelete, onAddAliases]);

    return (
        <section aria-label={definition.title}>
            <LookupToolbar appliedSearch={remote ? remote.search : search} definition={definition} onSearch={remote ? remote.onSearch : setSearch} status={status} onStatusChange={setStatus} showStatus={!remote} onAdd={onAdd} />
            <div className="settings-lookup__table">
                <Table
                    id={`lookup-${definition.id}`}
                    columns={tableColumns}
                    data={data}
                    loading={loading}
                    {...(remote ? {
                        pagination: remote.pagination, onPaginationChange: remote.onPaginationChange,
                        sorting: remote.sorting, onSortingChange: remote.onSortingChange, total: remote.total,
                    } : {})}
                    enableSearch={false}
                    enableFilters={false}
                    enableHideColumns={false}
                    enableSelection={false}
                    enableExpanding={false}
                    enableSorting
                    enablePagination
                    enablePaginateAll={false}
                    enableColumnVisibilityStorage={false}
                    enableGlobalFilterStorage={false}
                    enableUrlPagination={false}
                    pageSizes={[10, 25, 50]}
                    noDataMessage={remote?.error ? 'Records could not be loaded.' : (remote ? remote.search : search || status.value !== 'all') ? 'No matching records found.' : `No ${definition.title.toLowerCase()} available.`}
                />
            </div>
        </section>
    );
};

export default LookupTable;
